import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    text-align: center;
    padding: 60px 0;
`

const EmojiImg = styled.img`
    width: 100px;
`

const Title = styled.div`
    font-family: NexaBlack;
    font-size: 26px;
    height: 32px;
    letter-spacing: 0px;
    width: 350px;
    margin: 0 auto;
`

const Message = styled.div`
    color: rgb(255, 255, 255);
    font-size: 17px;
    font-weight: normal;
    height: 60px;
    letter-spacing: 0px;
    text-align: center;
    width: 361px;
    margin: 25px auto 0 auto;
`

const Welcome = () => {
    return (
        <Container>
            <EmojiImg src="https://media.giphy.com/media/LOnt6uqjD9OexmQJRB/giphy.gif" />
            <Title>Welcome to Super Cut</Title>
            <Message>To get started, either click “Upload from Computer” or paste a media URL.</Message>
        </Container>
    )
}

export default Welcome
